module.exports = __webpack_public_path__ + "static/img/ls6.65465ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls6.png
// module id = Vi/d
// module chunks = 12